import { DownloadIcon, } from "@chakra-ui/icons";
import {
    Image,
    Center,
    Container,
    Flex,
    Text,
    VStack,
    Heading,

} from "@chakra-ui/react";
import MyButton from "../../Components/Extra/MyButton";
import me from "../../assets/Propic300300.jpg";
import cv from '../../assets/Cv Md Rifat.pdf'
import ReactTyped from "react-typed";
const Banner = () => {
    var titles = ["Web Developer", "Web Designer", "Graphic Designer", "Programmer", "Video Animation", "SEO"];

    return (
        <Container maxW="container.lg" my={15} >
            <Flex direction={["column-reverse", "column-reverse", "row-reverse"]} className="dark:shadow-gray-700 dark:bg-gray-800 my-5 ">
                <Center className="flex-1 shadow hover:shadow-md dark:shadow-gray-700 py-4 rounded-lg">
                    <VStack p="4" alignItems={["center", "center", "start"]}>
                        <blockquote className="text-2xl font-semibold italic text-center text-slate-900">
                            <span className="before:block before:absolute before:-inset-1 before:-skew-y-3 before:bg-blue-300 before:dark:bg-lime-300 before:dark:text-gray-800 relative inline-block">
                                <span className="relative text-white ml-3 dark:text-gray-800">Hello !</span>
                            </span>
                            <span class="relative text-black ml-2 dark:text-white" >I'm</span>
                        </blockquote>
                        <Heading className="text-5xl sm:text-5xl font-extrabold sm:font-black ">
                            Md Rifat Nime
                        </Heading>
                        <Heading
                            className="text-5xl sm:text-4xl font-extrabold sm:font-black text-blue-300 dark:text-lime-300 py-1 "
                            noOfLines={1}
                        >
                            <ReactTyped strings={titles} typeSpeed={80} backSpeed={50} loop className="font-mono"/>
                        </Heading>
                        <Text textAlign={["center", "center", "left"]} className="font-mono font-medium text-xl">
                           Welcome to My portfolio site. Please Go Ahead And Explore More
                            about me.
                        </Text>
                        <MyButton
                            text={"Download CV"}
                            icon={<DownloadIcon mx="2px" />}
                            link={cv}
                        />
                    </VStack>
                </Center>
                <Center
                    w={["auto", "auto", 350, 400]}
                    className="shadow hover:shadow-md dark:shadow-gray-700 rounded-lg"
                >
                    <Image className="w-auto" fit={"cover"} src={"https://i.ibb.co/gWbZKZL/Propic300300.jpg"} align="top"></Image>
                </Center>
            </Flex>
        </Container>
    );
};

export default Banner;
